const de = {
  "ProviderAccess.RemoveAccess": "Zugang entfernen",
  "ProviderAccess.TestAccess": "Zugang prüfen",
  "ProviderAccess.TestSucceeded": "Der Anbieterzugang funktioniert.",
  "ProviderAccess.TestFailed": "Der Anbieterzugang konnte nicht geprüft werden.",
  "ProviderAccess.Provider": "Anbieter",
  "ProviderAccess.PanelTitle": "Anbieterzugänge",
  "ProviderAccess.ProviderPricingRefreshTitle": "Anbieterpreise",
  "ProviderAccess.ViewProviderPrices": "Anbieterpreise anzeigen",
  "ProviderAccess.ProviderPriceList": "Anbieterpreisliste",
  "ProviderAccess.NoProviderPricesAvailable": "Keine Anbieterpreise verfügbar",
  "Provider is still used by agents": "Dieser Anbieter wird noch von Agenten verwendet.",
  "ProviderPricingRefreshStatusPending": "ausstehend",
  "ProviderPricingRefreshStatusRunning": "läuft",
  "ProviderPricingRefreshStatusSuccess": "abgerufen",
  "ProviderPricingRefreshStatusWarning": "Warnung",
  "ProviderPricingRefreshStatusError": "Fehler",
  "ProviderPricingRefreshPendingDescription": "Die Anbieterpreise wurden seit dem Start noch nicht abgerufen.",
  "ProviderPricingRefreshRunningDescription": "Die Anbieterpreise werden gerade abgerufen.",
  "ProviderPricingRefreshSuccessDescription": "Letzter erfolgreicher Abruf: {time}. Aktualisierte Preise: {count}.",
  "ProviderPricingRefreshWarningDescription": "Einzelne Anbieterpreise konnten nicht aktualisiert werden.",
  "ProviderPricingRefreshForbiddenDescription": "Der Zugriff auf eine offizielle Preisquelle wurde verweigert.",
  "ProviderPricingRefreshErrorDescription": "Die Anbieterpreise konnten nicht aktualisiert werden.",
  "ProviderPricingDiagnostic.SourceAccessDenied": "Zugriff auf die Preisquelle verweigert",
  "ProviderPricingDiagnostic.SourceUnavailable": "Preisquelle nicht erreichbar",
  "ProviderPricingDiagnostic.SourceResponseInvalid": "Ungültige Antwort der Preisquelle",
  "ProviderPricingDiagnostic.SourceUrlUnsafe": "Preisquelle nicht mehr an der hinterlegten Adresse",
  "ProviderPricingDiagnostic.SnapshotStoreUnavailable": "Preise konnten nicht gespeichert werden",
  "ProviderPricingDiagnostic.SourceFormatUnrecognized": "Preisstruktur nicht erkannt",
  "ProviderPricingDiagnostic.InternalConfigurationRequired": "Kalkulatorische Kostenbasis fehlt",
  "ProviderPricingDiagnostic.InternalConfigurationInvalid": "Kalkulatorische Kostenbasis ist ungültig",
  "ProviderPricingDiagnostic.InternalConfigurationDuplicate": "Kalkulatorische Kostenbasis ist doppelt vorhanden",
  "ProviderPricingDiagnostic.AdapterMissing": "Preisadapter fehlt",
  "ProviderPricingDiagnostic.UnexpectedError": "Unerwarteter Fehler beim Preisabruf",
} as const;

const en = {
  "ProviderAccess.RemoveAccess": "Remove access",
  "ProviderAccess.TestAccess": "Test access",
  "ProviderAccess.TestSucceeded": "The provider connection works.",
  "ProviderAccess.TestFailed": "The provider connection could not be tested.",
  "ProviderAccess.Provider": "Provider",
  "ProviderAccess.PanelTitle": "Provider access",
  "ProviderAccess.ProviderPricingRefreshTitle": "Provider prices",
  "ProviderAccess.ViewProviderPrices": "View provider prices",
  "ProviderAccess.ProviderPriceList": "Provider price list",
  "ProviderAccess.NoProviderPricesAvailable": "No provider prices available",
  "Provider is still used by agents": "This provider is still used by agents.",
  "ProviderPricingRefreshStatusPending": "pending",
  "ProviderPricingRefreshStatusRunning": "running",
  "ProviderPricingRefreshStatusSuccess": "retrieved",
  "ProviderPricingRefreshStatusWarning": "warning",
  "ProviderPricingRefreshStatusError": "error",
  "ProviderPricingRefreshPendingDescription": "Provider prices have not been refreshed since startup.",
  "ProviderPricingRefreshRunningDescription": "Provider prices are being refreshed.",
  "ProviderPricingRefreshSuccessDescription": "Last successful refresh: {time}. Updated prices: {count}.",
  "ProviderPricingRefreshWarningDescription": "Some provider prices could not be updated.",
  "ProviderPricingRefreshForbiddenDescription": "Access to an official pricing source was denied.",
  "ProviderPricingRefreshErrorDescription": "Provider prices could not be updated.",
  "ProviderPricingDiagnostic.SourceAccessDenied": "Access to the pricing source was denied",
  "ProviderPricingDiagnostic.SourceUnavailable": "Pricing source unavailable",
  "ProviderPricingDiagnostic.SourceResponseInvalid": "Invalid response from the pricing source",
  "ProviderPricingDiagnostic.SourceUrlUnsafe": "Pricing source is no longer at the configured address",
  "ProviderPricingDiagnostic.SnapshotStoreUnavailable": "Prices could not be stored",
  "ProviderPricingDiagnostic.SourceFormatUnrecognized": "Pricing structure not recognized",
  "ProviderPricingDiagnostic.InternalConfigurationRequired": "Calculated cost basis is missing",
  "ProviderPricingDiagnostic.InternalConfigurationInvalid": "Calculated cost basis is invalid",
  "ProviderPricingDiagnostic.InternalConfigurationDuplicate": "Calculated cost basis is duplicated",
  "ProviderPricingDiagnostic.AdapterMissing": "Pricing adapter is missing",
  "ProviderPricingDiagnostic.UnexpectedError": "Unexpected pricing refresh error",
} as const;

export const sharedProviderAccessDe = de;
export const sharedProviderAccessEn = en;
export const sharedProviderAccessRu = {
  ...en,
  "ProviderAccess.RemoveAccess": "Удалить доступ",
  "ProviderAccess.TestAccess": "Проверить доступ",
  "ProviderAccess.TestSucceeded": "Подключение к поставщику работает.",
  "ProviderAccess.TestFailed": "Не удалось проверить подключение к поставщику.",
  "ProviderAccess.Provider": "провайдер",
  "ProviderAccess.PanelTitle": "доступы к провайдерам",
  "ProviderAccess.ProviderPricingRefreshTitle": "цены провайдеров",
  "ProviderAccess.ViewProviderPrices": "показать цены провайдеров",
  "ProviderAccess.ProviderPriceList": "прайс-лист провайдеров",
  "ProviderAccess.NoProviderPricesAvailable": "цены провайдеров недоступны",
  "Provider is still used by agents": "Этот провайдер ещё используется агентами.",
};
export const sharedProviderAccessUk = {
  ...en,
  "ProviderAccess.RemoveAccess": "Видалити доступ",
  "ProviderAccess.TestAccess": "Перевірити доступ",
  "ProviderAccess.TestSucceeded": "Підключення до постачальника працює.",
  "ProviderAccess.TestFailed": "Не вдалося перевірити підключення до постачальника.",
  "ProviderAccess.Provider": "постачальник",
  "ProviderAccess.PanelTitle": "доступи до постачальників",
  "ProviderAccess.ProviderPricingRefreshTitle": "ціни постачальників",
  "ProviderAccess.ViewProviderPrices": "показати ціни постачальників",
  "ProviderAccess.ProviderPriceList": "прайс-лист постачальників",
  "ProviderAccess.NoProviderPricesAvailable": "ціни постачальників недоступні",
  "Provider is still used by agents": "Цей постачальник ще використовується агентами.",
};
export const sharedProviderAccessIt = {
  ...en,
  "ProviderAccess.RemoveAccess": "Rimuovi accesso",
  "ProviderAccess.TestAccess": "Verifica accesso",
  "ProviderAccess.TestSucceeded": "Il collegamento al fornitore funziona.",
  "ProviderAccess.TestFailed": "Impossibile verificare il collegamento al fornitore.",
  "ProviderAccess.Provider": "fornitore",
  "ProviderAccess.PanelTitle": "accessi ai fornitori",
  "ProviderAccess.ProviderPricingRefreshTitle": "prezzi dei fornitori",
  "ProviderAccess.ViewProviderPrices": "mostra i prezzi dei fornitori",
  "ProviderAccess.ProviderPriceList": "listino prezzi dei fornitori",
  "ProviderAccess.NoProviderPricesAvailable": "prezzi dei fornitori non disponibili",
  "Provider is still used by agents": "Questo fornitore è ancora utilizzato dagli agenti.",
};
